import { styled, css, th } from '@elliemae/ds-system';
import { Grid } from '@elliemae/ds-grid';
import { DSComboBoxName, DSComboboxSlots } from '../../theming.js';

interface StyledControlsWrapperT {
  hasError: boolean;
  inline: boolean;
  minWidth?: number;
  disabled: boolean;
  applyAriaDisabled: boolean;
  readOnly: boolean;
}

const readOnlyBorder = css`
  border: 1px solid ${({ theme }) => theme.colors.neutral['080']};
  border-bottom: 1px solid ${({ theme }) => theme.colors.neutral[400]};
`;

const borderStyles = css<{ hasError: boolean; readOnly: boolean; applyAriaDisabled: boolean }>`
  border: 1px solid ${({ hasError, theme }) => (hasError ? theme.colors.danger[900] : theme.colors.neutral[400])};
  ${({ readOnly, applyAriaDisabled }) => (readOnly || applyAriaDisabled ? readOnlyBorder : '')}
`;

const backgroundStyles = css<{ disabled: boolean; applyAriaDisabled: boolean; readOnly: boolean }>`
  background: ${({ disabled, applyAriaDisabled, readOnly, theme }) => {
    if (readOnly || applyAriaDisabled) {
      return theme.colors.neutral['050'];
    }
    if (disabled) {
      return theme.colors.neutral['080'];
    }
    return '#ffffff';
  }};
`;

const focusBorder = css`
  outline: 2px solid ${({ theme }) => theme.colors.brand[700]};
  outline-offset: -2px;
`;

const hoverBorder = css`
  border: 1px solid ${({ theme }) => theme.colors.brand[600]};
`;

export const StyledControlsWrapper = styled(Grid, {
  name: DSComboBoxName,
  slot: DSComboboxSlots.INPUT_WRAPPER,
})<StyledControlsWrapperT>`
  ${backgroundStyles}
  position: relative;
  border-radius: 2px;
  min-width: ${({ minWidth, inline }) => (inline || !minWidth ? '' : `${minWidth}px`)};
  align-items: center;
  align-content: center;
  min-height: 28px;
  padding: 3px 0px 3px 8px;
  @media (max-width: ${th.breakpoint('small')}) {
    padding: 1.25px 0px 1.25px 8px;
  }
  margin: ${({ inline }) => (inline ? '10px 16px' : '')};
  ${borderStyles}
  &:hover {
    ${({ disabled }) => (!disabled ? hoverBorder : '')}
  }
  &:focus-within {
    ${focusBorder}
  }
`;

export const StyledSingleSelectWraper = styled.div<{
  disabled: boolean;
  applyAriaDisabled: boolean;
  readOnly: boolean;
}>`
  display: flex;
  width: 100%;
  align-items: center;
  color: ${({ disabled, readOnly, theme }) =>
    disabled || readOnly ? theme.colors.neutral['600'] : theme.colors.neutral['700']};
  user-select: ${({ disabled, applyAriaDisabled }) => (disabled || applyAriaDisabled ? 'none' : '')};
`;

export const StyledSelection = styled.div`
  font-size: 1rem;
  margin-right: 3px;
  display: flex;
`;

export const StyledHeaderActionsWrapper = styled(Grid)`
  height: 100%;
  .em-ds-button--text:focus::after {
    border: none;
  }
`;

export const StyleDropdownIndicator = styled.div``;

export const StyleHeaderActionsSeparator = styled.span<Partial<StyledControlsWrapperT>>`
  height: 100%;
  width: 1px;
  background-color: ${({ theme }) => theme.colors.neutral['400']};
`;
